export default __webpack_public_path__ + "static/media/banner3.e752e2f2.jpg";